<template>
  <div class='interactives-form'>
    <custom-input v-for='inputData in formData'
      :inputData='inputData'
      :key='inputData.name'
    />
    <div class="cont-btn-c"><button class="continue-button" @click="submitFields" :disabled="!valid"><slot>Submit</slot></button></div>
  </div>
</template>

<script>
import Input from '../../interactives-input/src/App.vue'

export default {
  name: 'interactives-form',
  props: ['formData', 'formValidator'],
  computed: {
    valid: function () {
      return this.formValidator ? this.formValidator(this.formData) : true
    }
  },
  methods: {
    submitFields () {
      this.$emit('submitForm', this.formData)
    }
  },
  components: {
    'custom-input': Input
  }
}
</script>

<style>
.interactives-form {
  /* styles go here */
}
</style>



// WEBPACK FOOTER //
// ../interactives-form/src/App.vue